import './style.css';

/*
       exemplo
<RADIO
                    disabled={!admin}
                    chave={'inputIESCampanha'}
                    avalores={['S', 'N']}
                    alabel={['Sim', 'Não']}
                    setValor={setIESCampanha}
                    valor={iescampanha}
                  />
*/

function RADIO(props){
   function setvalor(e){
       const index = props.index??-1;
       if(index>=0){
            props.setValor(e,index);
       }else{
           props.setValor(e);   
       }
   }
    return <div className="radio-control"    
                id={props.chave} 
                onChange={(e)=>setvalor(e.target.value)}>
              {                                        
              props.avalores.map((o, index) => {
                     const isChecked = String(o) === String(props.valor);
                     const radioId = `flexRadio-${props.chave}-${index}`;
                     
                     return <div key={`r${index}`} className="modern-radio-item">                                           
                            <input className="modern-radio-input"
                                   type="radio" 
                                   name={"flexRadioDefault"+props.chave}
                                   id={radioId}
                                   key={props.chave+o}
                                   onChange={(e)=>setvalor(e.target.value)}
                                   value={o}
                                   checked={isChecked}
                                   disabled={props.disabled}
                                   />
                            <label className={`modern-radio-label ${isChecked ? 'active' : ''}`} 
                                   htmlFor={radioId}>
                                   {props.alabel[index]}
                            </label>
                            </div>
              })
              }
              </div>
}

export default RADIO;